import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function DataDeletion() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email) { setError('Please enter your email address'); return; }
    try {
      await api.post('/data-deletion-request', { email }).catch(() => {});
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', padding: '40px 20px' }}>
      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Link to="/" style={{ display: 'inline-block', marginBottom: '24px' }}>
          <img src="/ggr-logo-deck.png" alt="Grand Gather Registry" style={{ height: '120px' }} />
        </Link>
        <div className="card" style={{ padding: '40px' }}>
          <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>Data Deletion Request</h1>
          <p style={{ color: 'var(--gray)', marginBottom: '24px', lineHeight: 1.6 }}>
            In accordance with data protection regulations, you can request the deletion of all personal data associated with your Grand Gather Registry account.
          </p>

          {submitted ? (
            <div style={{ padding: '20px', background: 'rgba(16,185,129,0.1)', borderRadius: '12px', textAlign: 'center' }}>
              <p style={{ fontSize: '16px', fontWeight: 600, color: '#10B981', marginBottom: '8px' }}>Request Received</p>
              <p style={{ fontSize: '14px', color: 'var(--gray)', lineHeight: 1.6 }}>
                If an account exists with this email, we will process your deletion request within 30 days. You will receive a confirmation email once complete.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <div style={{ padding: '12px', background: 'rgba(239,68,68,0.1)', borderRadius: '8px', color: 'var(--red)', marginBottom: '16px', fontSize: '14px' }}>{error}</div>}
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter the email linked to your account" required />
              </div>
              <p style={{ fontSize: '13px', color: 'var(--gray)', marginBottom: '16px', lineHeight: 1.5 }}>
                This will permanently delete your account, events, guest lists, and all associated data. This action cannot be undone.
              </p>
              <button type="submit" className="btn btn-primary btn-full">Submit Deletion Request</button>
            </form>
          )}

          <p style={{ marginTop: '24px', fontSize: '13px', color: 'var(--gray)' }}>
            You can also email us directly at <a href="mailto:support@grandgatherregistry.co.za" style={{ color: 'var(--gold-dark)' }}>support@grandgatherregistry.co.za</a> to request data deletion.
          </p>
        </div>
      </div>
    </div>
  );
}
